<app-loading-spinner *ngIf="appService.isLoading"></app-loading-spinner>

<div class="maunt-area form-container" style="width: 75vw;">
    <div style="display: flex;justify-content: space-between;">
        <div class="title" style="display: flex;width: fit-content;">{{(this.name?this.name:"FTL Fix Price_1").toUpperCase()}} FTL Fix Price Matrix</div>

        <div class="btn-right-area" style="display: inline-flex;align-items: center;margin-right: 10px;">
            <!-- <button mat-button-primary class="btn white-red-btn" style="padding: 0px 5px"
                (click)="onAddTrailer()"><mat-icon>add</mat-icon><span>Add Trailer</span></button> -->
                <div class="dropdown" *ngIf="selectTruckType.length >0 && operation!=='view'">
                    <button class="btn white-red-btn dropdown" *ngIf="operation!=='view'" (click)="dropDownSelct()" style="padding: 0px 5px"><mat-icon>add</mat-icon><span>Add Trailer</span></button>
                    <div class="dropdown-content" id="fixed-drop-down">
                        <div *ngFor="let i of selectTruckType" (click)="onAddTrailer(i)">{{i}}</div>
                      </div>
                  </div>
                  <img (click)="onExportdata()" class="download-icon icons"
                src="../../../../assets/images/download-icon.png" alt="Profile Picture">
        </div>
    </div>
    <table style="border: 1.5px solid #ccc;margin-bottom: 20px;" cellspacing="0" mat-table [dataSource]="dbDataSource">
        
        <tr class="accord-area">
            @for (i of destinCol; track $index) {
            <ng-container matColumnDef={{i}}>
               
                    <th mat-header-cell class="scrollable" style="background-color: #f2f2f2;"   [attr.colspan]="getColspan(i)" *matHeaderCellDef [ngClass]="{
                        'headerStyle': (i === 'Distance' || (i.split('-')[1] === 'del')),
                        'unsetstyle': !(i === 'Distance' || (i.split('-')[1] === 'del')),
                        'enable-field': operation !== 'view',
                        'disable-field': operation === 'view'
                      }">
                        @if (i === "Distance" || (i).split('-')[1] != 'del') {
                            <div style="text-transform: uppercase;text-align: left;font-weight: 600;">{{i ==="Distance"?'Service':i}}</div>
                        }
                        @else {
                            <span  style="color: #D40511;text-decoration: underline;cursor: pointer;" *ngIf="userData.RoleID===4" (click)="onDeleteTrailer(i)"><mat-icon style="color: #D40511;top: 10px;">delete</mat-icon> Delete</span>
                        }
                    </th>
            </ng-container>  
            }
            @for (i of displayedCol; track $index) {
            <ng-container matColumnDef={{i}}>
                <th mat-header-cell class="scrollable" style="font-weight: 600;" *matHeaderCellDef [ngClass]="{
                    'boderStyle': ((i.split('-')[1]) === 'roundtrip' || i === 'service'),
                    'unsetstyle': ((i.split('-')[1]) !== 'roundtrip' && i !== 'service'),
                    'enable-field': operation !== 'view',
                    'disable-field': operation === 'view'
                  }">
                    @if (i === "service") {
                        <div style="text-transform: uppercase;text-align: center;"></div>
                    }
                    @else {
                        <div  style="text-transform: uppercase;text-align: center;">{{(i).split("-")[1]}}</div>
                    }
                </th>
                
                    @if (i === "service") {
                        <ng-container *matCellDef="let element; let ind=index">
                             <!--commenting and removing 14 span single service item to 14-->
                                <!-- @if(ind ===0){
                               <td class="scrollable" mat-cell  rowspan="14" [ngClass]="{
                                    'enable-field': operation !== 'view',
                                    'disable-field': operation === 'view'
                                  }">
                                    <textarea value={{element[i]}} style="width: 200px; height: 690px;" (change)="onSrviceCall($event.target)" *ngIf="ind ===0" ></textarea>
                                </td> 

                            }-->
                                
                            <td class="scrollable" mat-cell  [ngClass]="{
                                'enable-field': operation !== 'view',
                                'disable-field': operation === 'view'
                              }">
                                <!-- rowspan="6" -->
                                <input type="text" style="width: 150px !important" value={{element[i]}} (change)="onSrviceCall($event.target, i,ind)"  >
                                <!-- <input type="text" style="pointer-events: none;background-color:#f2f2f2;"
                             value={{element[i]}}  /> -->
                            </td>
                           
                        </ng-container>
                        
                    }
                    @else {
                        <td class="scrollable" mat-cell *matCellDef="let element; let ind=index" [ngClass]="{
                            'boderStyle': ((i.split('-')[1]) === 'roundtrip' || i === 'service'),
                            'unsetstyle': ((i.split('-')[1]) !== 'roundtrip' && i !== 'service'),
                            'enable-field': operation !== 'view',
                            'disable-field': operation === 'view'
                          }" >
                        <input type="number" value={{formatElementData(element[i])}} (change)="onValueCahnge($event.target,i, ind)"/>
                    </td>
                    }

            </ng-container>
            }
        </tr>
        <tr mat-header-row *matHeaderRowDef="destinCol"></tr>
        <tr mat-header-row *matHeaderRowDef="displayedCol"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedCol;"></tr>
    </table>
</div>